export default (templateTheme = '') => {
    const container = document.getElementById('app');
    if (!container) {
        console.warn('No container');
        return container;
    }
    container.classList.add('page-content');
    return container;
}